<template>
  
  <div>

    <div class="ui large breadcrumb">
      <a v-if="$isCustomer()" class="section" @click="$historyBack()">
        <i class="reply icon m-r-5"></i>Sair
      </a>
      <router-link v-else to="/customers" class="section">
        <i class="reply icon m-r-5"></i>Clientes
      </router-link>
      <i class="right chevron icon divider"></i>
      <div class="section">
        <i class="info circle icon"></i> {{ customerCode + '-' + customerUnit }}
      </div>
      <span v-if="customer" class="animated fadeIn">
        <i class="right chevron icon divider"></i>
        <div class="section">
          {{ customer.name }}
        </div>
      </span>      
    </div>

    <div class="ui divider"></div>

    <div v-if="loading"><i class="spinner circle loading blue icon"></i> Carregando ...</div>

    <div v-if="!loading && customer" class="animated fadeIn">      
      
      <horizontal-tabs :tabs="tabs" @onSelectTab="onSelectTab" />

      <div class="ui basic segment no-padding no-margin tabs-container">

        <overview-tab v-if="activeTab == 'overview'" :customer="customer" />
        <address-tab v-if="activeTab == 'address'" :customer="customer" />
        <contact-tab v-if="activeTab == 'contact'" :customer="customer" />
        <fiscal-tab v-if="activeTab == 'fiscal'" :customer="customer" />
        <info-tab v-if="activeTab == 'info'" :customer="customer" />
        <quotations-tab v-show="activeTab == 'quotations'" :customer="customer" />
        <orders-tab v-show="activeTab == 'orders'" :customer="customer" />
        <invoices-tab v-show="activeTab == 'invoices'" :customer="customer" />
        <open-receivables-tab v-show="activeTab == 'receivables'" :customer="customer" />

      </div>

    </div>

  </div>

</template>

<script>

  import HorizontalTabs from "@/components/horizontal-tabs.vue"
  import OverviewTab from "./overview-tab.vue"
  import AddressTab from "./address-tab.vue"
  import ContactTab from "./contact-tab.vue"
  import FiscalTab from "./fiscal-tab.vue"
  import InfoTab from "./info-tab.vue"
  import QuotationsTab from "./quotations-tab.vue"
  import OrdersTab from "./orders-tab.vue"
  import InvoicesTab from "./invoices-tab.vue"
  import OpenReceivablesTab from "./open-receivables.vue"
  import CustomerService from "@/services/customer-service"
  import Calendar from "@/utils/calendar"

  export default {

    data() {
      return {
        loading: true,
        activeTab: "overview",
        customerCode: "",
        customerUnit: "",
        customer: null,
        tabs: [
          { id: "overview", label: "Visão Geral" },
          { id: "address", label: "Endereço" },
          { id: "contact", label: "Contato" },
          { id: "fiscal", label: "Fiscal" },
          { id: "info", label: "Outras Inf." },
          { id: "quotations", label: "Orçamentos" },
          { id: "orders", label: "Pedidos" },
          { id: "invoices", label: "Notas Fiscais" },
          { id: "receivables", label: "Títulos em Aberto" },
        ],
      }
    }, 

    components: {
      HorizontalTabs,
      OverviewTab,
      AddressTab,     
      ContactTab, 
      FiscalTab,
      InfoTab,
      QuotationsTab,
      OrdersTab,
      InvoicesTab,
      OpenReceivablesTab,
    },    

    created() {
      
      this.customerCode = this.$route.params.code
      this.customerUnit = this.$route.params.unit

      if (this.checkAccess())
        this.loadCustomer()
    },    

    mounted() {
      Calendar.initInputs()
    },

    methods: {

      checkAccess() {

        let unauthorized = false

        if (this.$isProspect()) {

          unauthorized = true

        } else if (this.$isCustomer()) {

          const customer = this.$store.state.user.customer

          if (!(customer.code == this.customerCode && customer.unit == this.customerUnit))
            unauthorized = true
        }

        if (unauthorized)
          this.$router.push("/not-found")

        return !unauthorized  
      },

      async loadCustomer() {

        this.loading = true

        try {

          this.customer = await CustomerService.getByCode(this.customerCode, this.customerUnit)

          this.loading = false
          
        } catch (error) {
          
          this.$errorHandler(error)
        }
      },

      onSelectTab(id) {
        this.activeTab = id
      },
    },
  }

</script>

